


const cantons = []
let activeCanton = null
let cantonsFilter = null
let currentMap = null
const items = []
const groups = []

const setActiveCanton = (canton) => {

  if (activeCanton) {
    activeCanton.element.setAttribute('class', 'map-canton')
    cantonsFilter.value = ''
  }

  if (canton === activeCanton?.key) {
    activeCanton = null
    canton = null
  }

  activeCanton = cantons.find((c) => c.key === canton)
  if (activeCanton) {
    cantonsFilter.value = activeCanton.key
    activeCanton.element.setAttribute('class', 'map-canton map-canton-active')
    currentMap.appendChild(activeCanton.element)
  }

  updateList()
}

const updateList = () => {

  const hasActiveFilter = activeCanton

  items.forEach((item) => {
    item.visible = item.cantons.includes(activeCanton?.key) || !activeCanton

    if (item.visible) {
      item.element.classList.remove('hidden')
    } else {
      item.element.classList.add('hidden')
    }
  })

  groups.forEach((group) => {
    const groupItems = group.items.filter((item) => item.visible)
    group.element.classList.toggle('hidden', groupItems.length === 0)

    group.element.style.order = group.canton === activeCanton?.key ? 1 : group.index
  })


  const url = new URL(window.location.href)
  if (activeCanton) {
    url.searchParams.set('canton', activeCanton.key)
  } else {
    url.searchParams.delete('canton')
  }
  window.history.replaceState({}, '', url)

}

document.querySelectorAll('[data-map-filter]').forEach((filter) => {

  currentMap = filter.querySelector('[data-map]')
  cantonsFilter = filter.querySelector('[data-filter-cantons]')

  const cantonElements = currentMap.querySelectorAll('path')

  cantonsFilter.addEventListener('change', (e) => {
    setActiveCanton(e.target.value)
  })

  cantonElements.forEach((canton, index) => {
    canton.setAttribute('class', 'map-canton')
    cantons.push({
      key: canton.id,
      element: canton,
      index: index + 5
    })

    canton.addEventListener('click', () => {
      setActiveCanton(canton.id)
    })
  })

  filter.querySelectorAll('[data-item]').forEach((item) => {
    const cantons = item.dataset.canton.split(',')

    items.push({
      element: item,
      cantons,
      visible: true,
    })
  })

  filter.querySelectorAll('[data-canton-group]').forEach((group, index) => {
    groups.push({
      element: group,
      canton: group.dataset.cantonGroup,
      items: items.filter((item) => item.cantons.includes(group.dataset.cantonGroup)),
      index: index + 5
    })
  })


  const urlParams = new URLSearchParams(window.location.search)
  const cantonParam = urlParams.get('canton')
  if (cantonParam) {
    setActiveCanton(cantonParam)
  }

})
